import api from "../../../api";



export const getVersionById = (id) => api.get(`/admin/mobile-app-versions/${id}`);
export function updateVersion(payload) {
    return api.put("/admin/mobile-app-versions/" + payload.id, payload);
}